import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";


const Vehicle_daily_progress_entry = () => {
  useAuthRedirect();
  const [data, setData] = useState([]);
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(localStorage.getItem("branch") || "");
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  

  const canView  = hasPermission("Hire Bill Approval - Branch", "view");
      const canEntry = hasPermission("Hire Bill Approval - Branch", "entry");
      const canEdit  = hasPermission("Hire Bill Approval - Branch", "edit");
      const canDel   = hasPermission("Hire Bill Approval - Branch", "del");
    

  // Fetch branches only once
  useEffect(() => {
  const fetchBillApprovalBranches = async () => {
    const updateProgress = (val) => {
      const bar = document.getElementById("progress-bar");
      const text = document.getElementById("progress-text");
      if (bar) bar.style.width = `${val}%`;
      if (text) text.innerText = `Loading... ${val}%`;
    };

    Swal.fire({
      title: "Loading Branches",
      html: `
        <div id="progress-container" style="width: 100%; background: #e0e0e0; border-radius: 5px;">
          <div id="progress-bar" style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); border-radius: 5px;"></div>
        </div>
        <p id="progress-text" style="margin-top: 10px; font-size: 14px;">Loading... 0%</p>
      `,
      showConfirmButton: false,
      allowOutsideClick: false,
      didOpen: () => updateProgress(0),
    });

    try {
      const response = await axios.get("https://rfs2.infraconsoft.net.in/api/bill_approval_list_branch");
      updateProgress(100);
      setBranches(response.data.branches || []);
      setTimeout(() => Swal.close(), 400);
    } catch (error) {
      console.error("Error fetching branches:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to load branches for bill approval.",
      });
    }
  };

  {canView && (
  fetchBillApprovalBranches()
  )}
}, []);


  // Fetch data based on selected branch
  useEffect(() => {
    if (selectedBranch) {
        setLoading(true); 
      axios.get(`https://rfs2.infraconsoft.net.in/api/bill_approval_list_branch?branch_code=${selectedBranch}`)
        .then((response) => {
          setData(response.data.vehicles);
          setFilteredData(response.data.vehicles);
          // console.log(response.data.vehicles);
          
        })
        .catch((error) => {
          console.error("Error fetching vehicles:", error);
        })
        .finally(() => {
            setLoading(false); 
          });
    }
  }, [selectedBranch]);

  // Handle page change
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Calculate indexes for pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  // Handle search filter
  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    const filtered = data.filter((item) => {
      return (
        (item.fld_equip && item.fld_equip.toLowerCase().includes(e.target.value.toLowerCase())) ||
        (item.fld_vehiname && item.fld_vehiname.toLowerCase().includes(e.target.value.toLowerCase())) ||
        (item.fld_billno && item.fld_billno.toLowerCase().includes(e.target.value.toLowerCase()))
      );
    });
    setFilteredData(filtered);
    setCurrentPage(1); // Reset to first page on search
  };

  const handleApprove = async (gbillid) => {
    if (!gbillid) return;
  
    // Show confirmation popup
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to approve this bill?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Approve!",
      cancelButtonText: "Cancel",
    });
  
    if (result.isConfirmed) {
      try {

        Swal.fire({
                      title: "Submitting...",
                      text: "Please wait while we process your request.",
                      allowOutsideClick: false,
                      didOpen: () => {
                        Swal.showLoading();
                      },
                    });


        const response = await axios.post("https://rfs2.infraconsoft.net.in/api/approve_bill", { gbillid });
        
        if (response.data.success) {
          // Show success alert
          Swal.fire({
            title: "Approved!",
            text: "Bill Approved Successfully!",
            icon: "success",
          });
          window.location.reload();
        } else {
          Swal.fire({
            title: "Failed!",
            text: "Failed to Approve Bill.",
            icon: "error",
          });
        }
      } catch (error) {
        console.error("Error approving bill:", error);
        Swal.fire({
          title: "Error!",
          text: "Error processing approval.",
          icon: "error",
        });
      }
    }
  };


  const handleDisapprove = async (gbillid, vcode, invoice) => {
    console.log("Received params:", { gbillid, vcode, invoice });
    
    if (!gbillid || !vcode || !invoice) {
      console.error("Invalid parameters:", { gbillid, vcode, invoice });
      return;
    }
  
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to disapprove this bill?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Disapprove!",
      cancelButtonText: "Cancel",
    });
  
    if (result.isConfirmed) {
      try {

        Swal.fire({
                      title: "Submitting...",
                      text: "Please wait while we process your request.",
                      allowOutsideClick: false,
                      didOpen: () => {
                        Swal.showLoading();
                      },
                    });

                    
        console.log("Sending request to backend...");
        const response = await axios.post("https://rfs2.infraconsoft.net.in/api/disapprove_bill", {
          gbillid,
          vcode,
          invoice,
        });
        
        
  
        if (response.data.success) {
          Swal.fire("Disapproved!", "Bill Disapproved Successfully!", "success");
          window.location.reload();
        } else {
          Swal.fire("Failed!", "Failed to Disapprove Bill.", "error");
        }
      } catch (error) {
        console.error("Error disapproving bill:", error);
        Swal.fire("Error!", "Error processing disapproval.", "error");
      }
    }
  };
  
 if (!canView) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">{selectedBranch} - Hire Bills List for Approval</h2>
          <div>
            <Time />
          </div>
        </section>

<div className="vehicle-class">
  <div>
    <p><b>Branch wise Report :</b></p>

    <select 
      value={selectedBranch} 
      onChange={(e) => setSelectedBranch(e.target.value)} 
      required 
      className="branch-select"
    >
      <option value="">Select Branch</option>
      {branches.map((item) => (
        <option key={item.branchMaster_code} value={item.branchMaster_code}>
          {item.branchMaster_name}
        </option>
      ))}
    </select>
  </div>
</div>


        {/* Search Filter */}
        <div className="search-filter">
          <p>Search: </p>
          <input type="text" placeholder="Search by vehicleName" value={searchTerm} onChange={handleSearch} className="search-input" />
        </div>

        <div className="content-table">
          <table>
            <thead>
            <tr>
                <th>S.No</th>
                <th>Bill No</th>
                <th>Vehicle Code</th>
                <th>Date</th>
                <th>Branch</th>
                <th>Vehicle Name</th>
                <th>Vehicle Type</th>
                <th>Company Name</th>
                {canEntry && (
                  <>
                <th>Approval</th>
                <th>Dis Approval</th>
                </>
                )}
                
                
              </tr>

            </thead>
            <tbody>
  {loading ? (
    <tr>
      <td colSpan="7" className="loading-text">Loading data, please wait...</td>
    </tr>
  ) : currentData.length > 0 ? (
    currentData.map((item, index) => (
      <tr key={index}>
        <td>{indexOfFirstItem + index + 1}</td>
        <td><Link to={`/ho_view_bill_approval/${item.fld_gbillid}/${item.fld_branchid}`}>{item.fld_billno}</Link></td>
        <td>{item.fld_equip}</td>
        <td>{new Date(item.fld_billdate).toLocaleDateString()}</td>
        <td>{item.fld_branchid}</td>
        <td>{item.fld_vehiname}</td>
        <td>{item.fld_vehitype}</td>
        <td>{item.fld_partyname}</td>
         {canEntry && (
                  <>
        <td>
  <button class="approve-btn" onClick={() => handleApprove(item.fld_gbillid)}>
    ✅ Approve
  </button>
</td>
<td>
  <button class="disapprove-btn" onClick={() => handleDisapprove(item.fld_gbillid, item.fld_equip, item.fld_billno)}>
    ❌ Disapprove
  </button>
</td>
 </>
                )}
                
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="7">No Data Available</td>
    </tr>
  )}
</tbody>

          </table>
        </div>

        {/* Pagination Controls */}
        <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>Previous</button>
          <button onClick={() => paginate(1)} className={currentPage === 1 ? 'active' : ''}>1</button>
          {filteredData.length > 0 &&
            [...Array(Math.min(3, Math.ceil(filteredData.length / itemsPerPage) - 1))].map((_, index) => {
              const pageNumber = currentPage + index;
              if (pageNumber > 1 && pageNumber <= Math.ceil(filteredData.length / itemsPerPage)) {
                return (
                  <button key={pageNumber} onClick={() => paginate(pageNumber)} className={currentPage === pageNumber ? 'active' : ''}>
                    {pageNumber}
                  </button>
                );
              }
              return null;
            })
          }
          <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}> Next</button>
        </div>
      </div>
    </div>
  );
};

export default Vehicle_daily_progress_entry;
